import axios from "axios";
import React, { useState } from "react";
import { discountGroupObjects } from "./data";
import { GlobalState } from "context/GlobalContext";
import BrandChannel from "./BrandChannel/BrandChannel";
import ApplicableDate from "./ApplicableDateSection/ApplicableDate";
import DiscountValueSection from "./DiscountValueSection/DiscountValueSection";
import { Box, Button, Step, StepLabel, Stepper, Typography } from "@mui/material";
import MasterGeneralInformation from "./MasterGeneralInformation/MasterGeneralInformation";
import ProductSelectionSection from "./ProductSelectionSection/ProductSelectionSection";
import StoreAvailabilitySection from "./StoreAvailabilitySection/StoreAvailabilitySection";
import DiscountOverview from "./DiscountOverview/DiscountOverview";

function DiscountMaster() {
	const initial_state = {
		[discountGroupObjects.brand_channel.key]: {
			brand: "",
			channel: "",
		},
		[discountGroupObjects.general_information.key]: {
			scheme_type: "",
			scheme_name: "",
			brand: "",
			scheme_description: "",
		},
		[discountGroupObjects.applicable_date.key]: {
			start_date: "",
			end_date: "",
			applicable_days: [],
		},
		[discountGroupObjects.store_availability.key]: {
			region: [],
			store: [],
			distributer: [],
			state: [],
			city: [],
		},
		[discountGroupObjects.discount_value.key]: [],
		[discountGroupObjects.product_selection.key]: {
			discount_product: [],
			nod: [],
		},
	};

	const [value, setValue] = useState(initial_state);
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

	const handleSubmit = async () => {
		setLoadingOpen(true);
		try {
			const res = await axios.post("/api/mbo_payment_working/save_discount_details", value);
			if (res.status === 201) {
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Discount Scheme created successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setValue(initial_state);
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Failed to create scheme ${error}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setValue(initial_state);
		} finally {
			setLoadingOpen(false);
		}
	};

	return (
		<Box width="100%" pt={4}>
			<Box display="flex" flexDirection={"row"} width={"98%"}>
				<Box width={"45%"}>
					<Stepper orientation="vertical">
						<Step expanded>
							<StepLabel>Brand and Channel Selection</StepLabel>
							<Box mt={2} mb={4}>
								<BrandChannel value={value} setValue={setValue} />
							</Box>
						</Step>
						<Step expanded>
							<StepLabel>Store Availability</StepLabel>
							<Box mt={2} mb={4} width={"90%"}>
								<StoreAvailabilitySection value={value} setValue={setValue} />
							</Box>
						</Step>
						<Step expanded>
							<StepLabel>Product Selection</StepLabel>
							<Box mt={2} mb={4}>
								<ProductSelectionSection value={value} setValue={setValue} />
							</Box>
						</Step>

						<Step expanded>
							<StepLabel>Applicable Date</StepLabel>
							<Box mt={2} mb={4} width={"90%"}>
								<ApplicableDate value={value} setValue={setValue} />
							</Box>
						</Step>
						<Step expanded>
							<StepLabel>General Information</StepLabel>
							<Box mt={2} mb={4}>
								<MasterGeneralInformation value={value} setValue={setValue} />
							</Box>
						</Step>
						<Step expanded>
							<StepLabel>Discount Value</StepLabel>
							<Box mt={2} mb={4} width={"90%"}>
								<DiscountValueSection value={value} setValue={setValue} />
							</Box>
						</Step>
					</Stepper>
				</Box>
				<Box width={"60%"} display={"flex"}>
					<DiscountOverview />
				</Box>
			</Box>
			<Box mt={4} display="flex" justifyContent="flex-end">
				<Button variant="contained" onClick={handleSubmit}>
					Submit
				</Button>
			</Box>
		</Box>
	);
}

export default DiscountMaster;
